import { services } from "../config/services";
import { customFetch } from "../customFetch";
import { Sorter } from "../sorter";
import {
  CanaryFile,
  CoreSensitivity,
  EndpointLogLevel,
} from "../types/response/endpoints";
import {
  AutoUpdateVersionPolicy,
  InstallerBuildMode,
} from "../types/response/installers";
import { ConfigPlatform } from "@/utils/platforms";

type GetGroupConfigsParams = {
  page: number;
  pageSize: number;
  companyId: string;
  platform?: ConfigPlatform;
  sorter?: Sorter;
};

export interface GroupConfigRequest {
  name: string;
  platform: ConfigPlatform;
  isAutoUpdateEnabled: boolean;
  autoUpdateBuildMode: InstallerBuildMode;
  isAutoUpdateProtectedBuildEnabled: boolean;
  autoUpdateVersionPolicy: AutoUpdateVersionPolicy;
  specificAutoUpdateVersion?: string;
  isQuarantineEnabled: boolean;
  isStartupGuardEnabled: boolean;
  isCoreEnabled: boolean;
  isCanaryEnabled: boolean;
  isBaselineEnabled: boolean;
  isMemoryDumpEnabled: boolean;
  isProcessProtectionEnabled: boolean;
  isRegistryProtectionEnabled: boolean;
  isFileSystemProtectionEnabled: boolean;
  isTamperEventReportingEnabled: boolean;
  isAppListCollectionEnabled: boolean;
  isLogCollectionEnabled: boolean;
  minLogLevel: EndpointLogLevel;
  hashPurgingTimeoutHours: number;
  heartbeatIntervalSeconds: number;
  protectedDirectories: string[];
  allowedPaths: string[];
  tamperReportingExcludedPaths: string[];
  allowedRemoteIps: string[];
  canaryFiles: CanaryFile[];
  coreSensitivity: CoreSensitivity;
  isSmbMonitoringEnabled: boolean;
  isSmbLockdownEnabled: boolean;
  firewallRuleTimeoutMinutes: number | null;
  isAggerServicesHidingEnabled: boolean;
  isEnhancedMemoryProtectionEnabled: boolean;
}

export const groupConfigs = {
  getGroupConfig: (id: string) => customFetch(`${services.groupConfigs}/${id}`),
  getGroupConfigsByName: (companyId: string, name: string) =>
    customFetch(
      `${services.groupConfigs}?CompanyId=${companyId}&Name=${name}&PageSize=20`,
    ),
  getGroupConfigs: ({
    page,
    pageSize,
    companyId,
    platform,
    sorter,
  }: GetGroupConfigsParams) => {
    let url = `${services.groupConfigs}?CompanyId=${companyId}&PageNumber=${page}&PageSize=${pageSize}`;
    if (platform) {
      url += `&Platform=${platform}`;
    }
    if (sorter) {
      url += `&OrderBy=${sorter.orderBy}&OrderDirection=${sorter.orderDirection}`;
    }
    return customFetch(url);
  },
  addGroupConfig: (params: GroupConfigRequest & { companyId: string }) =>
    customFetch(`${services.groupConfigs}`, {
      method: "POST",
      body: JSON.stringify(params),
    }),
  deleteGroupConfig: (id: string) =>
    customFetch(`${services.groupConfigs}/${id}`, {
      method: "DELETE",
    }),
  updateGroupConfig: (id: string, params: GroupConfigRequest) =>
    customFetch(`${services.groupConfigs}/${id}`, {
      method: "PUT",
      body: JSON.stringify(params),
    }),
};
